import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpCacheKeyPrefix, HttpExtras } from '@lib/core';
import { EnvService } from '@lib/env';
import { Observable } from 'rxjs';
import { UriBuilder } from 'uribuilder';
import { OciCatalog } from './types/OciCatalog';
import { IOciSearchResponse } from './types/IOciSearchResponse';
import { OciBasketProductDto } from './types/IOciBasketProductDto';

export interface AddOciProductToBasketRequestFromEproc {
    product: OciBasketProductDto;
    catalogId: string;
    quantity: number;
}

@Injectable({
    providedIn: 'root',
})
export class OciDataService {
    private readonly http = inject(HttpClient);
    private readonly env = inject(EnvService);


    public getCustomerCatalogs(): Observable<OciCatalog[]> {
        const uri: UriBuilder = this.getBase('oci', 'catalogs');

        return this.http.get<OciCatalog[]>(uri.toString(), {
            params: HttpExtras.CACHE_KEY_PREFIX(HttpCacheKeyPrefix.CATALOG),
        });
    }

    public search(query: string, catalogId: string): Observable<IOciSearchResponse> {
        const uri: UriBuilder = this.getBase('oci', 'search');
        uri.query.searchFor = query;
        uri.query.catalog = catalogId;

        return this.http.get<IOciSearchResponse>(uri.toString(), {
            params: new HttpExtras({
                customErrorhandling: true,
                cacheKeyPrefix: HttpCacheKeyPrefix.CATALOG,
            }),
        });
    }

    public addOciProductToBasketFromEproc(
        product: OciBasketProductDto,
        catalogId: string,
        quantity: number,
    ): Observable<void> {
        const uriBuilder: UriBuilder = this.env.getBase('basket', 'add-product', 'oci', 'eproc');

        return this.http.post<void>(uriBuilder.toString(), {
            product,
            catalogId,
            quantity,
        } as AddOciProductToBasketRequestFromEproc);
    }

    private getBase(...pathSegments): UriBuilder {
        const uri: UriBuilder = this.env.getBase();
        uri.pathSegments = [...uri.pathSegments, ...pathSegments];

        return uri;
    }
}
